module.exports = __webpack_public_path__ + "img/listapremi.1a04d412.png";